import React from 'react'
import '../Assets/Css/AttendanceDaysShowCard.scss';
import Calander from "../Assets/Images/Attendance/ic-solar_calendar-mark-bold-duotone.svg"
import Map from "../Assets/Images/Attendance/fluent_location-48-filled.svg"

function AttendanceDaysShowCard(props) {
    return (
        <div class="card">
            <div className='card-cont'>
                <div class="card-title">{props.title || "-"}</div>
                <div class="card-value">{props.qty || 0}</div>
            </div>
            <div class="card-icon">
                <img src={props.img || Calander} alt='Calander' />
            </div>
        </div>

    )
}

export default AttendanceDaysShowCard
